import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { FullPageWrapperComponent } from './components/full-page-wrapper/full-page-wrapper.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PasswordInputDirective } from './directives/password-input.directive';
import { NgxMaskModule } from 'ngx-mask';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BreadcrumbComponent } from './layout/breadcrumb/breadcrumb.component';
import { ToastrModule } from 'ngx-toastr';
import { ToAnyPipe } from './pipes/to-any.pipe';
import { ToSurvey } from './pipes/translate-survey.pipe';
import { ToDatePipe } from './pipes/to-date.pipe';
import { GridComponent } from './layout/grid/grid.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ArchwizardModule } from 'angular-archwizard';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SelectableTableComponent } from './components/form/selectable-table/selectable-table.component';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgSelectModule } from '@ng-select/ng-select';
import { LocalizationComponent } from './components/localization/localization.component';
import { InputTextComponent } from './form/input-text/input-text.component';
import { ValidateFieldsService } from './services/validate-fields.service';
import { ErrorFieldComponent } from './layout/error-field/error-field.component';
import { InputSelectComponent } from './form/input-select/input-select.component';
import { InputCheckboxComponent } from './form/input-checkbox/input-checkbox.component';
import { InputSearchCNPJComponent } from './form/input-search-cnpj/input-search-cnpj.component';
import { TreeModule } from '@circlon/angular-tree-component';
import { InputSearchCpfComponent } from './form/input-search-cpf/input-search-cpf.component';
import { DragulaModule } from 'ng2-dragula';
import { ConfirmModalComponent } from './modal/confirm-modal/confirm-modal.component';
import { ReschedulingModalComponent } from './modal/rescheduling-modal/rescheduling-modal.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { PageSizeSelectorComponent } from './components/page-size-selector/page-size-selector.component';
import { BrandImageComponent } from './components/brand-image/brand-image.component';
import { InputTextareaComponent } from './form/input-textarea/input-textarea.component';

import { InputAutocompleteComponent } from './form/input-autocomplete/input-autocomplete.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ButtonSearchComponent } from './components/button-search/button-search.component';
import { FormFillingModalComponent } from './modal/form-filling-modal/form-filling-modal.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RegionModalComponent } from './modal/region-modal/region-modal.component';
import { InvalidFormModalComponent } from './modal/invalid-form-modal/invalid-form-modal.component';
import { MultiSelectDropdownComponent } from './form/multi-select-dropdown/multi-select-dropdown.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import {MatSelectModule} from '@angular/material/select';
import { ManualRegisterComponent } from './components/manual-register/manual-register.component';
import { RedistributionRuleModalComponent } from './modal/redistribution-rule-modal/redistribution-rule-modal.component';
import { TagInputModule } from 'ngx-chips';
import { SidebarSingleComponent } from './layout/sidebar-single/sidebar-single.component';
import { BrokerCodeRegistrationModalComponent } from './modal/broker-code-registration-modal/broker-code-registration-modal.component';

@NgModule({
  declarations: [
    PageNotFoundComponent,
    FullPageWrapperComponent,
    PasswordInputDirective,
    SidebarComponent,
    BreadcrumbComponent,
    ToAnyPipe,
    ToSurvey,
    ToDatePipe,
    GridComponent,
    LocalizationComponent,
    SelectableTableComponent,
    ErrorFieldComponent,
    InputTextComponent,
    InputSelectComponent,
    InputCheckboxComponent,
    InputSearchCNPJComponent,
    InputSearchCpfComponent,
    ConfirmModalComponent,
    ReschedulingModalComponent,
    PaginatorComponent,
    PageSizeSelectorComponent,
    BrandImageComponent,
    InputTextareaComponent,
    InputAutocompleteComponent,
    ButtonSearchComponent,
    FormFillingModalComponent,
    RegionModalComponent,
    InvalidFormModalComponent,
    MultiSelectDropdownComponent,
    ManualRegisterComponent,
    SidebarSingleComponent,
    BrokerCodeRegistrationModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgSelectModule,
    FormsModule,
    AlertModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    DragulaModule.forRoot(),
    BsDropdownModule.forRoot(),
    NgxMaskModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    ToastrModule.forRoot(),
    ArchwizardModule,
    MatDialogModule,
    TreeModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatSelectModule,
  ],
  exports: [
    CommonModule,
    RouterModule,
    DragulaModule,
    AlertModule,
    ToastrModule,
    TooltipModule,
    NgSelectModule,
    ArchwizardModule,
    BsDropdownModule,
    ModalModule,
    FormsModule,
    NgxMaskModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    PageNotFoundComponent,
    FullPageWrapperComponent,
    PasswordInputDirective,
    SidebarComponent,
    BreadcrumbComponent,
    GridComponent,
    MatDialogModule,
    SelectableTableComponent,
    LocalizationComponent,
    ErrorFieldComponent,
    InputTextComponent,
    InputSelectComponent,
    InputCheckboxComponent,
    InputSearchCNPJComponent,
    InputSearchCpfComponent,
    TreeModule,
    ConfirmModalComponent,
    ReschedulingModalComponent,
    PaginatorComponent,
    PageSizeSelectorComponent,
    BrandImageComponent,
    InputTextareaComponent,
    InputAutocompleteComponent,
    MatAutocompleteModule,
    ButtonSearchComponent,
    MatProgressBarModule,
    ManualRegisterComponent,
    SidebarSingleComponent
  ],
  providers: [
    ValidateFieldsService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    PaginatorComponent
  ]
})
export class SharedModule { }
